import { OTHER_OPTION } from "~/common/constants";
import { PharmacyQueryType } from "~/common/types/pharmacies";
import { Option } from "~/common/utils";

export const generatePharmaciesOptions = (
  data?: PharmacyQueryType[],
): Option[] => [
  ...(data
    ? data.map(({ pharmacy, id }) => ({
        label: `${pharmacy.name} - ${pharmacy.address.street} ${pharmacy.address.city}`,
        value: id,
      }))
    : []),
  OTHER_OPTION,
];
